import { useEffect, useState } from "react";
import { Radio, RadioGroup } from "@headlessui/react";
import { classNames } from "../../../AppNav";

export const colorCodes = [
  { name: "Blue", color: "text-blue-500", code: "#3b82f6" },
  { name: "Pink", color: "text-pink-500", code: "#f6339a" },
  { name: "Yellow", color: "text-yellow-500", code: "#fadb14" },
  { name: "Teal", color: "text-teal-500", code: "#14b8a6" },
  { name: "Green", color: "text-green-500", code: "#10b981" },
  { name: "Purple", color: "text-purple-500", code: "#a855f7" },
  { name: "Rose", color: "text-rose-500", code: "#ed4956" },
  { name: "Gray", color: "text-neutral-500", code: "#6b7280" },
  { name: "Amber", color: "text-amber-500", code: "#f59e0b" },
  { name: "Indigo", color: "text-indigo-500", code: "#5c6ac4" },
  { name: "Sky", color: "text-sky-500", code: "#0ea5e9" },
  { name: "Lime", color: "text-lime-500", code: "#718096" },
  { name: "Orange", color: "text-orange-500", code: "#f56565" },
  { name: "Fuchsia", color: "text-fuchsia-500", code: "#c044b5" },
  { name: "Violet", color: "text-violet-500", code: "#7c3aed" },
  { name: "Red", color: "text-red-500", code: "#ef4444" },
  { name: "Brown", color: "text-neutral-700", code: "#a1887f" },
  { name: "Cyan", color: "text-cyan-500", code: "#22c55e" },
];

export const colors = colorCodes.map((colorCode) => colorCode.code);

export const ColorPicker = ({ onSelectItem, color, pickerId = "" }) => {
  const [selectedColor, setSelectedColor] = useState(colorCodes[0]);

  useEffect(() => {
    const item = colorCodes.find((item) => item.color == color);
    setSelectedColor(item);
  }, [color]);

  return (
    <div className={"max-w-60"}>
      <RadioGroup
        value={selectedColor}
        onChange={setSelectedColor}
        className="grid grid-cols-6 gap-1.5"
      >
        {colorCodes.map((option) => (
          <Radio
            key={`${pickerId}-${option.name}`}
            value={option}
            aria-label={option.name}
            onClick={() => {
              onSelectItem(option);
            }}
            style={{ color: option.code }}
            className={({ focus, checked }) =>
              classNames(
                focus && checked ? "ring-1 ring-offset-1" : "",
                !focus && checked ? "ring-2" : "",
                "relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5 ring-current focus:outline-hidden"
              )
            }
          >
            <span
              aria-hidden="true"
              className="h-6 w-6 rounded-full border border-opacity-10 bg-current"
            ></span>
          </Radio>
        ))}
      </RadioGroup>
    </div>
  );
};
